import script from "./KanbanBoardRoutes.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanBoardRoutes.vue?vue&type=script&setup=true&lang=js"

import "./KanbanBoardRoutes.vue?vue&type=style&index=0&id=79f53bb4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f53bb4"]])

export default __exports__